<template>
  <div>
    <div
      class="col-12"
      style="padding: 0;"
      v-if="!justView && addQuestionTemplate === 'default'"
    >
      <div class="row likert-emotion-row">
        <div
          class="col-xl-6 mt-auto mb-auto likert-emotion-text"
          :style="{
            color: textColor || '#000000',
          }"
        >
          {{ text }}
        </div>


        <div class="col-xl-6 mt-auto mb-auto likert-emotion-metric">
          <div>
            <!-- angry -->
          <i
              class="fas fa-angry angry icon-view"
              :class="review === 1 ? 'selected' : ''"
              @click="setReview($event, itemId, 1)"
            ></i>

          <!-- frowm -->
          <i
            class="fas fa-frown frown icon-view"
            :class="review === 2 ? 'selected' : ''"
            @click="setReview($event, itemId, 2)"
          ></i>

          <!-- grin -->
          <i class="fas fa-meh meh icon-view"
            :class="review === 3 ? 'selected' : ''"
            @click="setReview($event, itemId, 3)"
          ></i>

          <!-- meh -->
          <i class="fas fa-smile smile icon-view"
            :class="review === 4 ? 'selected' : ''"
            @click="setReview($event, itemId, 4)"
            ></i>

          <!-- smile -->
          <i class="fas fa-grin grin icon-view"
            :class="review === 5 ? 'selected' : ''"
            @click="setReview($event, itemId, 5)"
          ></i>
          </div>

          <applicable
            v-if="applicableEnabled"
            :itemId="index"
            v-model="applicabled"
            :selectedButton="selectedButton"
            @click.native="selectedButton = !selectedButton"
            :lang="lang"
          />
        </div>
      </div>

      <comment-area
        :clickButton="expandComment"
        :template="addQuestionTemplate"
        v-if="commentEnabled && !justView"
        v-model="comment"
      />
    </div>
    <div v-else-if="!justView && addQuestionTemplate !== 'default'">
      <div class="col-12">
        <div
          style="display: flex; justify-content: center; padding-bottom: 20px;"
          :style="{
            color: textColor || '#000000',
          }"
        >
          {{ text }}
        </div>

        <div style="display: flex; justify-content: center; align-items: center;">

         <div>
          <!-- angry -->
          <i
              class="fas fa-angry angry icon-view icon-large"
              :class="review === 1 ? 'selected' : ''"
              @click="setReview($event, itemId, 1)"
            ></i>

          <!-- frowm -->
          <i
            class="fas fa-frown frown icon-view icon-large"
            :class="review === 2 ? 'selected' : ''"
            @click="setReview($event, itemId, 2)"
          ></i>

          <!-- grin -->
          <i class="fas fa-meh meh icon-view icon-large"
            :class="review === 3 ? 'selected' : ''"
            @click="setReview($event, itemId, 3)"
          ></i>

          <!-- meh -->
          <i class="fas fa-smile smile icon-view icon-large"
            :class="review === 4 ? 'selected' : ''"
            @click="setReview($event, itemId, 4)"
            ></i>

          <!-- smile -->
          <i class="fas fa-grin grin icon-view icon-large"
            :class="review === 5 ? 'selected' : ''"
            @click="setReview($event, itemId, 5)"
          ></i>
         </div>

          <applicable
            style="margin-top: -15px; display: flex; flex: none"
            v-if="applicableEnabled"
            :itemId="index"
            v-model="applicabled"
            :selectedButton="selectedButton"
            @click.native="selectedButton = !selectedButton"
            :lang="lang"
          />
        </div>
      </div>

      <comment-area
        :clickButton="expandComment"
        :template="addQuestionTemplate"
        v-if="commentEnabled && !justView"
        v-model="comment"
      />
    </div>

    <div v-else-if="justView">
      <div class="col-12" style="padding: 0;">
        <div class="row">
          <div
            class="col-6"
            :style="{
              color: textColor || '#000000',
            }"
          >
            <span :class="`${this.$route.fullPath.includes('treatments') ? 'text-addquestion' : ''}`"> {{ text }} </span>
          </div>

          <div class="col-6 text-right">
            <i
              class="fas fa-angry icon-view"
              :style="
                reviewAnswer === 1
                  ? `color: ${colorAngry}`
                  : `color: ${grayDefault}`
              "
            ></i>

            <i
              class="fas fa-frown icon-view"
              :style="
                reviewAnswer === 2
                  ? `color: ${colorFrown}`
                  : `color: ${grayDefault}`
              "
            ></i>

            <i
              class="fas fa-meh icon-view"
              :style="
                reviewAnswer === 3
                  ? `color: ${colorGrin}`
                  : `color: ${grayDefault}`
              "
            ></i>

            <i
              class="fas fa-smile icon-view"
              :style="
                reviewAnswer === 4
                  ? `color: ${colorMeh}`
                  : `color: ${grayDefault}`
              "
            ></i>

            <i
              class="fas fa-grin icon-view"
              :style="
                reviewAnswer === 5
                  ? `color: ${colorSmile}`
                  : `color: ${grayDefault}`
              "
            ></i>

            <applicable
              v-if="reviewAnswer === -1"
              :justView="justView"
              :itemId="index"
            />
          </div>
        </div>
      </div>

      <comment-area
        :clickButton="expandComment"
        :template="addQuestionTemplate"
        v-if="commentEnabled && !justView"
        v-model="comment"
      />
    </div>
    <hr />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import commentArea from '../comment-area';
import applicable from '../applicable';
import faceAngry from '../../../../assets/face-angry-solid.svg';
import faceFrown from '../../../../assets/face-frown-solid.svg';
import faceGrin from '../../../../assets/face-grin-solid.svg';
import faceMeh from '../../../../assets/face-meh-solid.svg';
import faceSmile from '../../../../assets/face-smile-solid.svg';

export default {
  name: 'LikertEmotion',

  components: {
    commentArea,
    applicable,
  },

  props: {
    textColor: { type: String, required: false },
    text: { type: String, required: true },
    itemId: { type: String, required: true },
    index: { type: Number, required: true },
    justView: { type: Boolean, default: false },
    selected: { type: Number },
    colorTemplate: { type: String, required: false, default: 'colors' },
    commentEnabled: { type: Boolean, default: false },
    applicableEnabled: { type: Boolean, default: false },
    hasComment: { type: String, default: null },
    reviewAnswer: { type: Number, required: false },
    addQuestionTemplate: { type: String, required: true, default: 'default' },
    idQuestion: { type: String, required: true },
    lang: { type: String, required: false, default: 'br' },
  },
  data: () => ({
    position: null,
    metric: null,
    review: null,
    comment: null,
    applicabled: null,
    selectedButton: false,
    buttons: null,
    expandComment: false,
    faceAngry,
    faceFrown,
    faceGrin,
    faceMeh,
    faceSmile,
    grayDefault: '#BDBDBD',
    colorAngry: '#E53420',
    colorFrown: '#F27D2E',
    colorGrin: '#F2D52E',
    colorMeh: '#A6E06E',
    colorSmile: '#37E688',
  }),
  watch: {
    comment: function watchComment() {
      this.update();
    },
    applicabled: function watchApplicated(value) {
      this.$emit('input', {
        review: value,
        comment: this.comment,
        position: this.itemId,
        _id: this.idQuestion,
      });
    },
    selectedButton: function watchSelectedButton(value) {
      if (value) {
        this.selectedButton = true;
        this.review = null;

        if (this.buttons) {
          this.buttons.forEach((element) => {
            element.classList.remove('active');
          });
        }

        this.$emit('input', {
          review: -1,
          comment: this.comment,
          position: this.itemId,
          _id: this.idQuestion,
        });
      }

      // else if (this.grade !== this.review) {
      //   event.target.classList.add('active');
      //   this.review = this.grade;
      // }
    },
    review: function watchReview(value) {
      if (value) {
        this.expandComment = true;
        this.review = value;
      } else {
        this.expandComment = false;
      }
    },
  },
  methods: {
    setReview(event, clazz, grade) {
      const $elements = document.querySelectorAll(`.item-likert-${clazz}`);

      this.buttons = $elements;

      // $elements.forEach((element) => {
      //   element.classList.remove('active');
      // });

      if (grade === this.review) {
        // event.target.classList.add('active');
        this.review = null;
      } else {
        this.review = grade;
      }

      this.update();
    },

    update() {
      this.selectedButton = false;

      this.$emit('input', {
        review: this.review,
        comment: this.comment,
        position: this.itemId,
        _id: this.idQuestion,
      });
    },
  },
  computed: {
    ...mapState('research', ['likertReview']),
    ...mapState('templates', ['list', 'templateSelected']),
  },
  mounted() {
    this.position = this.$store.state.research.likertControl;
    this.$store.state.research.likertControl += 1;

    this.metric = this.$store.state.actions.action.type;

    const buttonsNotApply = document.querySelectorAll('.applicabled');

    if (this.applicableEnabled) {
      for (let index = 0; index < buttonsNotApply.length; index += 1) {
        buttonsNotApply[index].style.display = 'flex';
      }
    } else {
      for (let index = 0; index < buttonsNotApply.length; index += 1) {
        buttonsNotApply[index].style.display = 'block';
      }
    }

    if (this.$route.name === 'Detalhes da tratativa') {
      for (let index = 0; index < buttonsNotApply.length; index += 1) {
        buttonsNotApply[index].style.display = 'block';
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
.icon-view {
  font-size: 22px;
  margin-left: 10px;
  color: $gray;
  cursor: pointer;
}

.icon-large {
  font-size: 40px;
}

@media screen and (max-width: 460px) {
  .icon-large {
    font-size: 38px;
  }
  .icon-view {
    margin-left: 5px;
  }
}

@media screen and (max-width: 390px) {
  .icon-large {
    font-size: 30px;
  }
}

@media screen and (max-width: 350px) {
  .icon-large {
    font-size: 6vw;
  }
}


.angry {
  color: #BDBDBD;
  &:hover, &.selected {
  color: #E53420;
 }
}

.frown {
  color: #BDBDBD;
  &:hover, &.selected {
  color: #F27D2E;
 }
}

.grin {
  color: #BDBDBD;
  &:hover, &.selected {
  color: #37E688;
 }
}

.meh {
  color: #BDBDBD;
  &:hover, &.selected {
  color: #F2D52E;
 }
}

.smile {
  color: #BDBDBD;
  &:hover, &.selected {
  color: #A6E06E;
 }
}

.face {
  width: 23px;
  cursor: pointer;
  margin: 2px;
}

.face-big {
  width: 45px;
  cursor: pointer;
  margin: 2px;
  margin-top: 10px;
}
.likert-emotion-text {
  text-align: left;
}

.likert-emotion-metric {
  display: flex;
  flex-direction: row;
  justify-content: end;
  align-items: end;
}

@media screen and (max-width: 1200px) {
  .likert-emotion-text {
    text-align: center;
  }
  .likert-emotion-metric {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/metrics/likert-emotion/index.vue